import { Component,Inject,OnInit,PLATFORM_ID,Renderer2,TemplateRef,ViewChild } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { FormGroup } from '@angular/forms';
import { FormBuilder,Validators } from '@angular/forms';
import { MainserviceService } from 'src/app/mainservice.service';
import Swal from 'sweetalert2';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { MatDatepicker } from '@angular/material/datepicker';
import { Title, Meta } from '@angular/platform-browser';
import { JsonLdService, SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';

@Component({
  selector: 'app-medeilhq',
  templateUrl: './medeilhq.component.html',
  styleUrls: ['./medeilhq.component.scss'],
  providers:[MainserviceService,DatePipe]
})
export class MedeilhqComponent {

  enquiryForm:FormGroup;
  totalcountry:any=[];
  captcha:any
  errorcaptcha:any
  ecaptcha:boolean=false;
  dialcode:any;
  showElement: boolean = false;
  showElementsave: boolean = false;
  @ViewChild('picker') picker!: MatDatepicker<Date>;
  @ViewChild('inputField') inputField!: any;
  currentTime: Date;
  timeSlots:any=[];
  timezone:any;
  appointment_time:boolean=false;
  selectedTime: string | null = null;
  leads:any;
  constructor(
    private ngxsmartservice: NgxSmartModalService,
    private fb: FormBuilder,
    private seoService: SeoSocialShareService,
    private jsonLdService: JsonLdService,
    private mainservice: MainserviceService,
    private datePipe: DatePipe,
    private title: Title,
    private meta: Meta,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Initialize form with default values
    this.enquiryForm = this.fb.group({
      leadname: ['', [Validators.required]],
      organizationname: ['', [Validators.required]],
      leadsourceid: ['', []],
      leadsource: ['medeil website', []],
      sourceRef1: ['', []],
      sourceRef2: ['', []],
      description: ['', [Validators.required]],
      primaryphone: ['', [Validators.required]],
      primaryemail: ['', [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$')]],
      address1: ['', []],
      address2: ['', []],
      country: ['', []], // Initialize empty, will set later
      countryname1: ['0', []],
      state: ['', []], // Initialize empty, will set later
      city: ['', []], // Initialize empty, will set later
      enteredcaptcha: ['', []],
      generatedcaptcha: ['', []],
      phonedialcode: ['', []],
      checkbox: [false, []],
      appfrmtime: ['', []],
      apptotime: ['', []],
      appointmentdate: ['', []],
    });
    this.setSeoMeta();
    // Only run browser-specific code in the browser
    if (isPlatformBrowser(this.platformId)) {

      this.setSchema();
      this.setFaqSchemaData();
      this.setWebsiteSchema();

      // Set values from sessionStorage
      this.enquiryForm.patchValue({
        country: sessionStorage.getItem('country'),
        state: sessionStorage.getItem('state'),
        city: sessionStorage.getItem('city')
      });

      this.timezone = sessionStorage.getItem('timezone');
    }
  }
  // setSeoMeta() {
  //   const seoData: SeoSocialShareData = {
  //     title: 'MedeilCloud HQ – Centralized Control for Multi-Stores',
  //     description: 'Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.',
  //     image: 'https://www.medeil.com/assets/medeilcloud-hq.jpg',
  //     url: 'https://www.medeil.com/medeil-cloud-hq',
  //     keywords: 'Multi-store management, Centralized inventory control, Chain pharmacy software, Retail management solution, MedeilCloud HQ, Sales analytics, Customer data management, Scalable business solutions'
  //   };

  //   this.seoService.setData(seoData);
  // }
  // setWebsiteSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "WebSite",
  //     "name": "MedeilCloud HQ",
  //     "url": "https://www.medeil.com",
  //     "description": "Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.",
  //     "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
  //     "publisher": {
  //       "@type": "Organization",
  //       "name": "Medeil",
  //       "url": "https://www.medeil.com",
  //       "logo": {
  //         "@type": "ImageObject",
  //         "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
  //       }
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setSchema() {
  //   const schemaData = {
  //     "@context": "https://schema.org",
  //     "@type": "SoftwareApplication",
  //     "name": "MedeilCloud HQ",
  //     "url": "https://www.medeil.com/medeil-cloud-hq",
  //     "description": "Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.",
  //     "applicationCategory": "BusinessApplication",
  //     "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
  //     "image": "https://www.medeil.com/assets/medeilcloud-hq.jpg",
  //     "offers": {
  //       "@type": "Offer",
  //       "priceCurrency": "USD",
  //       "availability": "https://schema.org/InStock",
  //       "url": "https://www.medeil.com/medeil-cloud-hq",
  //       "keywords": "Multi-store management, Centralized inventory control, Chain pharmacy software, Retail management solution, MedeilCloud HQ, Sales analytics, Customer data management, Scalable business solutions"
  //     },
  //     "aggregateRating": {
  //       "@type": "AggregateRating",
  //       "ratingValue": "4.6",
  //       "ratingCount": "8864"
  //     },
  //   };

  //   this.jsonLdService.setData(schemaData);
  // }
  // setFaqSchemaData() {
  //   const faqSchema = {
  //     "@context": "https://schema.org",
  //     "@type": "FAQPage",
  //     "mainEntity": [
  //       {
  //         "@type": "Question",
  //         "name": "What is software for chain pharmacies?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "A specialist software program created to address the particular requirements of pharmacy chains with numerous sites is called chain pharmacy software. It offers centralized management capabilities for managing all branches' operations, inventory, prescription processing, and patient care."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Which characteristics make up chain pharmacy software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Features like centralized management, support for many stores, integrated point-of-sale systems, real-time inventory tracking, unified patient information, reporting and analytics, security and compliance, and scalability to meet the demands of pharmacy chains are commonplace in chain pharmacy software."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "How is efficiency increased by chain pharmacy software?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Chain pharmacy software allows managers to optimize inventory levels, standardize procedures, make data-driven decisions, and expedite operations by offering centralized management and real-time access to data from all branches. This lowers operating expenses and increases efficiency throughout the chain."
  //         }
  //       },
  //       {
  //         "@type": "Question",
  //         "name": "Does software for chain pharmacies have development potential?",
  //         "acceptedAnswer": {
  //           "@type": "Answer",
  //           "text": "Yes, software for chain pharmacies is made to grow with the pharmacy chain. In order to adapt to operational changes, future growth plans, and changing business requirements, it provides scalable features, adaptable workflows, and flexible deployment options."
  //         }
  //       }
  //     ]
  //   };

  //   this.addJsonLdToHead(faqSchema);
  // }

//   setSeoMeta() {
//     const seoData: SeoSocialShareData = {
//       title: $localize`:@@MEDEIL_CLOUD_HQ_TITLE:MedeilCloud HQ – Centralized Control for Multi-Stores`,
//       description: $localize`:@@MEDEIL_CLOUD_HQ_DESCRIPTION:Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.`,
//       image: 'https://www.medeil.com/assets/medeilcloud-hq.jpg',
//       url: 'https://www.medeil.com/medeil-cloud-hq',
//       keywords: $localize`:@@MEDEIL_CLOUD_HQ_KEYWORDS:Multi-store management, Centralized inventory control, Chain pharmacy software, Retail management solution, MedeilCloud HQ, Sales analytics, Customer data management, Scalable business solutions`
//     };

//     this.seoService.setData(seoData);
// }

setSeoMeta() {
  const supportedLanguages = ['en', 'fr', 'es', 'pt'];
  let finalUrl = '';

  const seoData = {
    title: $localize`:@@MEDEIL_CLOUD_HQ_TITLE:MedeilCloud HQ – Centralized Control for Multi-Stores`,
    description: $localize`:@@MEDEIL_CLOUD_HQ_DESCRIPTION:Manage chain pharmacies and multi-store operations with MedeilCloud HQ. Centralize sales, inventory & customer data.`,
    keywords: $localize`:@@MEDEIL_CLOUD_HQ_KEYWORDS:Multi store management, Centralized inventory control, Chain pharmacy software, Retail management solution, MedeilCloud HQ, Point of Sales analytics software, Customer data management, Scalable business solutions, free hospitality software, best hospitality software, hospital management software,multi-store POS, POS headquarters, centralized POS, retail chain management, pharmacy chain POS, POS analytics, inventory control, MEDEIL Cloud HQ`,
    image: 'https://www.medeil.com/assets/medeilcloud-hq.jpg',
    url: '' // we will fill it below
  };

  if (isPlatformBrowser(this.platformId)) {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const parts = path.split('/');

    let lang = 'en'; // Default language
    if (supportedLanguages.includes(parts[1])) {
      lang = parts[1];
    }

    const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
    finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    seoData.url = finalUrl;
  } else {
    // Server Side - you can use a default fallback URL or from environment/server
    seoData.url = 'https://www.medeil.com/en'; // You can adjust based on your default language
  }

  // Set SEO tags
  this.title.setTitle(seoData.title);

  const metaTags = [
    { name: 'description', content: seoData.description },
    { name: 'keywords', content: seoData.keywords },
    { property: 'og:title', content: seoData.title },
    { property: 'og:description', content: seoData.description },
    { property: 'og:url', content: seoData.url },
    { property: 'og:type', content: 'website' },
    { property: 'og:image', content: seoData.image }
  ];

  metaTags.forEach(tag => this.meta.updateTag(tag));
}



setWebsiteSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": $localize`:@@MEDEIL_CLOUD_HQ_NAME:MedeilCloud HQ`,
      "url": "https://www.medeil.com",
      "description": $localize`:@@MEDEIL_CLOUD_HQ_DESCRIPTION:Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.`,
      "image": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png",
      "publisher": {
        "@type": "Organization",
        "name": "Medeil",
        "url": "https://www.medeil.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.medeil.com/assets/img/logo/medeil_logo_1.png"
        }
      },
    };

    this.jsonLdService.setData(schemaData);
}

setSchema() {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": $localize`:@@MEDEIL_CLOUD_HQ_NAME:MedeilCloud HQ`,
      "url": "https://www.medeil.com/medeil-cloud-hq",
      "description": $localize`:@@MEDEIL_CLOUD_HQ_DESCRIPTION:Explore MedeilCloud HQ, the comprehensive solution for managing chain pharmacies and multi-store operations. Centralize control over inventory, sales, and customer data to enhance efficiency and consistency across all locations.`,
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Cloud-based (Web, Windows, macOS, Linux)",
      "image": "https://www.medeil.com/assets/medeilcloud-hq.jpg",
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock",
        "url": "https://www.medeil.com/medeil-cloud-hq",
        "keywords": $localize`:@@MEDEIL_CLOUD_HQ_KEYWORDS:Multi-store management, Centralized inventory control, Chain pharmacy software, Retail management solution, MedeilCloud HQ, Sales analytics, Customer data management, Scalable business solutions`
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.6",
        "ratingCount": "8864"
      },
    };

    this.jsonLdService.setData(schemaData);
}

setFaqSchemaData() {
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": $localize`:@@FAQ_QUESTION_1_HQ:What is software for chain pharmacies?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ_ANSWER_1_HQ:A specialist software program created to address the particular requirements of pharmacy chains with numerous sites is called chain pharmacy software. It offers centralized management capabilities for managing all branches' operations, inventory, prescription processing, and patient care.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ_QUESTION_2_HQ:Which characteristics make up chain pharmacy software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ_ANSWER_2_HQ:Features like centralized management, support for many stores, integrated point-of-sale systems, real-time inventory tracking, unified patient information, reporting and analytics, security and compliance, and scalability to meet the demands of pharmacy chains are commonplace in chain pharmacy software.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ_QUESTION_3_HQ:How is efficiency increased by chain pharmacy software?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ_ANSWER_3_HQ:Chain pharmacy software allows managers to optimize inventory levels, standardize procedures, make data-driven decisions, and expedite operations by offering centralized management and real-time access to data from all branches. This lowers operating expenses and increases efficiency throughout the chain.`
          }
        },
        {
          "@type": "Question",
          "name": $localize`:@@FAQ_QUESTION_4_HQ:Does software for chain pharmacies have development potential?`,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": $localize`:@@FAQ_ANSWER_4_HQ:Yes, software for chain pharmacies is made to grow with the pharmacy chain. In order to adapt to operational changes, future growth plans, and changing business requirements, it provides scalable features, adaptable workflows, and flexible deployment options.`
          }
        }
      ]
    };

    this.addJsonLdToHead(faqSchema);
}



  addJsonLdToHead(schema: any) {
    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schema);
    script.id = 'faq-schema';

    // Remove old schema if it exists
    const oldScript = document.getElementById('faq-schema');
    if (oldScript) {
      oldScript.remove();
    }

    this.renderer.appendChild(document.head, script);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.mainservice.generatecaptcha();
      this.captcha = localStorage.getItem('captcha')
       // ----country list--
       this.mainservice.getCountryList().subscribe(data=>{
         console.log(data);
         this.totalcountry=data;
       })
    }

  }
  selectedclass: number = 1;

  selectclass(index: number): void {
    this.selectedclass = index;
  }
  appointment(datasource:any){
    this.enquiryForm.get('sourceRef1').setValue(datasource);
    this.ngxsmartservice.open('enquirypos');
    // this.ngxsmartservice.open('appointmentform');
  }
  closeModal(): void {
    this.ngxsmartservice.close('enquirypos');
    this.ngxsmartservice.close('appointmentform');
    this.enquiryForm.reset();
    this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();

  }
  countrychange(){

    this.mainservice.getMobileCode(this.enquiryForm.get('countryname1').value).subscribe((data)=>{
      //console.log(data);
      this.dialcode=data.Dailingcode;
      console.log(this.dialcode);
     // this.registerForm.get('phonedialcode').patchValue(this.dialcode[1]);
    })
  }
  checkCaptcha(){

    var usercaptcha = this.enquiryForm.get('enteredcaptcha').value

    if (this.captcha == usercaptcha) {
      this.ecaptcha = false

    } else {

      this.errorcaptcha = 'Enter correct Captcha'
      this.ecaptcha = true
    }
  }
  generatecaptcha(){
    this.mainservice.generatecaptcha()
    this.captcha = localStorage.getItem('captcha')
  }
  submitenquery(){
    let valid=this.validation();
    if(valid){
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.open('appointmentform');
      this.picker.open();
      this.inputField.focus();
    }

  }

  validation(){
    let name=this.enquiryForm.get('leadname').value
    let organizationname=this.enquiryForm.get('organizationname').value
    let primaryemail=this.enquiryForm.get('primaryemail').value
    let primaryphone=this.enquiryForm.get('primaryphone').value
    let captcha=this.enquiryForm.get('enteredcaptcha').value
    let checkbox=this.enquiryForm.get('checkbox').value

    // var usercaptcha = this.registerForm.get('enteredcaptcha').value
    if(!name){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!organizationname){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Organization Name',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryemail){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Email',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!primaryphone){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Your Mobile Number',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(!captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(captcha != this.captcha){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Enter Correct Captcha',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }
    else if(checkbox==false){
      Swal.fire({
        position: 'center',
        icon: 'warning',
        title: 'Please Select Accept & Terms condition',
        showConfirmButton: false,
        timer: 1500
      })
      return false;
    }


    return true
  }
  slectdate(event: any){
    this.showElement=true;
    const selectedDate = event.value;
    const finalDate = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.enquiryForm.get('appointmentdate').setValue(finalDate);
   this.currentTime = new Date();

   let map={
    "timezone":this.timezone,
    "orginaltimezone":this.currentTime
  }
  this.mainservice.gettimeSlots(map).subscribe(data=>{
    this.timeSlots = data[0].map((time:any)=> {
      const [hours, minutes] = time.split(':');
      const hours12 = ((parseInt(hours) + 11) % 12) + 1;
      const ampm = parseInt(hours) < 12 ? 'AM' : 'PM';
      return `${hours12}:${minutes} ${ampm}`;
    });
    this.showElement=false;
    console.log(this.timeSlots);
  })

    this.appointment_time=true;
  }
  selectTime(time: string): void {
    const currentTime = new Date();
    const formattedTime = this.datePipe.transform(currentTime, 'hh:mm:ss a');
    console.log(formattedTime);
    this.selectedTime = time;
    // this.enquiryForm.get('apptotime').setValue(time);
    this.enquiryForm.get('appfrmtime').setValue(time);

  }
  savelead(){
    this.showElementsave=true;



    // if (valid) {

      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElementsave=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('enquirypos');
      this.ngxsmartservice.close('appointmentform');
      this.enquiryForm.reset();
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      // this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();
  })

  }
  closepopup(){
    this.ngxsmartservice.close('myModal');
    this.enquiryForm.reset();

    this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();

  }
  trynowbtn(data:any){
    // this.enquiryForm.reset();
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal');

  }
  savesignup(){


    let valid=this.validation();

    if (valid) {
      this.showElement=true;
      let phone = this.enquiryForm.get('primaryphone').value

      let mobileno=this.enquiryForm.get('phonedialcode').value+this.enquiryForm.get('primaryphone').value
      this.enquiryForm.get('primaryphone').setValue(mobileno)

       console.log('form',this.enquiryForm.value);

  this.mainservice.savelead(this.enquiryForm.value).subscribe((data: any) => {
    this.leads = data
    // console.log("this.leads",this.leads)
    if (data) {
      // this.enquiryForm.reset()
      // window.location.href= 'https://www.vanuston.com/thank-u-vanuston'
      this.enquiryForm.reset();
      this.showElement=false;
      // this.submitenquery();
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Data saved successfully',
        text: 'We will contact you shortly.',
        showConfirmButton: false,
        timer: 4000
      });
      this.ngxsmartservice.close('myModal');
    }
     else{
      this.enquiryForm.get('primaryphone').setValue(phone);
      this.showElement=false;
    }
    this.enquiryForm.get('countryname1').setValue('0');
      this.generatecaptcha();

  })

    }
    else{
      this.showElement=false;
    }


  }

  broucher(data:any){
    this.enquiryForm.get('sourceRef1').setValue(data);
    this.ngxsmartservice.open('myModal1');
  }
  savebroucher() {
    let valid = this.validation();


    if (valid) {
      this.showElementsave = true;
      let phone = this.enquiryForm.get('primaryphone').value;
      let mobileno = this.enquiryForm.get('phonedialcode').value + this.enquiryForm.get('primaryphone').value;
      this.enquiryForm.get('primaryphone').setValue(mobileno);

      console.log('form', this.enquiryForm.value);

      this.mainservice.savelead(this.enquiryForm.value).subscribe(
        (data: any) => {

          this.leads = data;

          if (data) {
            this.enquiryForm.reset();
            this.showElementsave = false;
            Swal.fire({
              title: "Do you want to view the Brochure?",
              // showDenyButton: true,
              // showCancelButton: true,
              confirmButtonText: "yes",

            }).then((result) => {

              if (result.isConfirmed) {

            const url = 'https://medeilpos.blob.core.windows.net/websitedocuments/Medeilcloud_HQ_Brochure.pdf';
            window.open(url, '_blank');
              }
            });
            this.ngxsmartservice.close('myModal1');


          } else {
            this.enquiryForm.get('primaryphone').setValue(phone);
            this.showElement = false;
          }

          this.enquiryForm.get('countryname1').setValue('0');
          this.generatecaptcha();
        },
        (error: any) => {
          console.error('Error saving form', error);
          this.enquiryForm.get('primaryphone').setValue(phone);
          this.showElement = false;
        }
      );
    } else {
      this.showElement = false;
    }
  }
}
